import { CreateActionReport } from "root/rfp-hotel/ActionReport";

export function checkAndExecute(check, executable, errorStatus){
  return check() ? executable() : Promise.reject({status: errorStatus || 400})
}

export function checkAndExecuteToActionReport(check, executable, errorStatus){
  return checkAndExecute(check, () => executable().then(CreateActionReport), errorStatus)
}
